import { render, staticRenderFns } from "./LessonRecords.vue?vue&type=template&id=4aaa4da2&scoped=true&lang=html"
import script from "./LessonRecords.vue?vue&type=script&lang=js"
export * from "./LessonRecords.vue?vue&type=script&lang=js"
import style0 from "./LessonRecords.vue?vue&type=style&index=0&id=4aaa4da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa4da2",
  null
  
)

export default component.exports